<template>
  <div
    class="eCAnalysisPage mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="contentWrap">
      <div class="tabList">
        <TabsCom :tabList="tabList" @getTabsActive="getTabsActive" />
      </div>
      <div class="centerBox">
        <ECAssessment
          v-if="activeItem.name == '能耗评估'"
          :authority="authority"
        />
        <Evaluation
          v-if="activeItem.name == '指标评估'"
          :authority="authority"
        />
        <YoyAnalysis v-if="activeItem.name == '同比分析'" />
        <RingAnalysis v-if="activeItem.name == '环比分析'" />
        <EnergySankey v-if="activeItem.name == '桑基分析'" />
      </div>
    </div>
  </div>
</template>

<script>
import TabsCom from "@/components/nengyuanguanli/TabsCom.vue";
import YoyAnalysis from "./YoyAnalysis.vue";
import EnergySankey from "./EnergySankey.vue";
import RingAnalysis from "./RingAnalysis.vue";
import ECAssessment from "@/components/nengyuanguanli/ECAnalysis/ECAssessment.vue";
import Evaluation from "@/components/nengyuanguanli/ECAnalysis/Evaluation.vue";
import { handleExportAuthority } from "@/assets/utils/handleData.js";
import { judgeAuthority } from "@/assets/js/utils";
export default {
  components: {
    TabsCom,
    YoyAnalysis,
    EnergySankey,
    RingAnalysis,
    ECAssessment,
    Evaluation,
  },
  data() {
    return {
      authority: false,
      tabList: [
        // { name: "能耗评估" },
        // { name: "指标评估" },
        { name: "同比分析" },
        { name: "环比分析" },
        { name: "桑基分析" },
      ],
      activeIndex: 0,
      activeItem: {},
    };
  },
  methods: {
    getTabsActive(val) {
      // console.log(val);
      this.activeIndex = val.index;
      this.activeItem = this.tabList[val.index];
    },
  },
  created() {
    this.authority = judgeAuthority(handleExportAuthority(this.$route.path));
  },
};
</script>

<style lang="scss" scoped>
.eCAnalysisPage {
  .contentWrap {
    @include setPage;
    @include setFlexColumn;
    justify-content: space-between;
    .tabList {
      width: 100%;
      height: 10%;
    }
    .centerBox {
      width: 100%;
      height: calc(90% - 16px);
    }
  }
}
</style>
